import { $, html, type Html, on, View } from 'rune-ts';
import { LegacyProductThumbnail } from '../ProductThumbnail/LegacyProductThumbnail.ts';
import klass from './PhotoReview.module.scss';
import { getResizedImage100WebpUrl } from '../../../../shared/util/getResizedImageUrl';
import { head, range } from '@fxts/core';
import { creatorPriceOfProduct } from '../../../../../../modules/ProductColorPrice/S/fs';
import { MONEY_SIGN } from '../../../../shared/constant';
import { UtilS } from '../../../../../../modules/Util/S/Function/module/UtilS';
import { dataStr } from '../../../../shared/util/dataStr';
import { classes, htmlIf, strMap } from '../../../../shared/util';
import { REVIEW_SCORE_COUNT } from './constant';
import { formatTimeElapsed } from '../../../../shared/util/date';
import { MShopAppCommunityF } from '../../../../../../modules/MShop/App/Community/F/Function/module/MShopAppCommunityF';
import { ProductThumbnailOption } from '../../../../features/ProductList/type';
import { PhotoReviewTypeS } from '../../../../features/PhotoReview/outbound/share';
import { font } from '@services/MarppleShop/shared/typography';
import { MShopAppCommunityDetailTmplS } from '@modules/MShop/App/Community/Detail/S/Tmpl/module/MShopAppCommunityDetailTmplS';

export class PhotoReviewCard extends View<PhotoReviewTypeS.PhotoReviewCardType> {
  thumbnail_option: ProductThumbnailOption = {
    klass: klass.product_thumbnail_img,
    resize_width: 52,
    // is_lazy: true,
    img_alt: `${this.data.name}'s product review thumbnail image`,
  };

  protected override template(data: PhotoReviewTypeS.PhotoReviewCardType): Html {
    const review_img_src = head(data.files)!.url;

    return html`<div class="${klass.photo_review_card}">
      <div class="${klass.review_photo}">
        <img src="${getResizedImage100WebpUrl(review_img_src, 342 * 2)}" alt="Review thumbnail image" />

        <a
          class="${klass.product_container}"
          href="/${T.lang}/${UtilS.escape(data.$one.stores.domain_name)}/products/${data.product_id}"
          data-post-message="${dataStr({
            screen: {
              type: 'util',
              title: T('mshop::상품상세'),
              uri: `/${T.lang}/${UtilS.escape(data.$one.stores.domain_name)}/products/${data.product_id}`,
            },
          })}"
        >
          <div class="${klass.product_thumbnail_wrap}">
            ${new LegacyProductThumbnail(this.data, this.thumbnail_option)}
          </div>
          <div class="${klass.product_info_wrap}">
            <div class="${klass.store_name} ${font('12_medium')}">${data.$one.stores.name || ''}</div>
            <div class="${klass.product_name} ${font('12_medium')}">
              ${html.preventEscape(data.name || data.base_product_name || '')}
            </div>
            <div class="${klass.product_price} ${font('12_medium')}">
              ${htmlIf(this.makeMoneySignHtml(), ET.lang !== 'kr')} ${this.priceOfProduct}
              ${htmlIf(this.makeMoneySignHtml(), ET.lang == 'kr')}
            </div>
          </div>
        </a>
      </div>
      <div class="${klass.score_container}">
        <div class="${klass.score}">
          ${strMap(
            (i) =>
              `<div class="${klass.star} ${classes({
                [klass.fill]: this.data.score > i,
              })}"></div>`,
            range(REVIEW_SCORE_COUNT),
          )}
        </div>
        <div class="${klass.created_at} ${font('12_medium')}">${formatTimeElapsed(data.created_at)}</div>
      </div>

      <div class="${klass.comment} ${font('14_medium')}">
        ${html.preventEscape(MShopAppCommunityDetailTmplS.reviewListComment(data))}
      </div>
    </div>`;
  }

  @on('click')
  _onClick(e: Event) {
    /* product 영역을 클릭하면 동작하지 않는다. */
    if ($(e.target)!.closest(`.${klass.product_container}`)) {
      return;
    }

    this.openReviewDetail();
  }

  private makeMoneySignHtml() {
    return html`<span class="${font('12_medium')}">${MONEY_SIGN[ET.lang]}</span>`;
  }

  private get priceOfProduct() {
    return UtilS.commify(creatorPriceOfProduct(this.data));
  }

  private openReviewDetail() {
    MShopAppCommunityF.openDetail({
      article_id: this.data.article_id,
      parent_cont_el: $(this.element()).parentNode()?.element(),
      parent_items: [this.element()],
      no_replace_url: undefined,
      title: undefined,
      is_product_review: false,
      is_list: false,
      is_rune: true,
      closingWithRune: () => {},
    });
  }
}
